import { compose, withProps } from 'recompose'
import { ShopByTires } from 'components/VehicleConfigurator'

export default compose(
  withProps({ isModal: true })
)(ShopByTires)
